import { OBSERVER, PRESENTER, WATCH, READONLY, DIAL_IN, CONTROLLER, Role } from '../../dataStore/constants/roles'
import { v4 as uuid } from 'uuid'

export const _WATCH_NAME_PREFIX = 'brightTALK-viewer'
export const _OBSERVER_PREFIX = 'brightTALK-observer'
export const _READ_ONLY_PREFIX = 'brightTALK-ro'
export const _DIAL_IN_PREFIX = 'brightTALK-dialin'
export const _CONTROLLER_PREFIX = 'brightTALK-controller'

/**
 * This method determines the username relative to their role
 * @param role The user's role.
 * @returns A string representing their username.
 */
function getUsername (role: Role, BTID = ''): string {

  switch (role) {

    case WATCH:
      return `${_WATCH_NAME_PREFIX}-${uuid()}`
    case OBSERVER:
      return `${_OBSERVER_PREFIX}-${BTID}`
    case PRESENTER:
      return BTID
    case DIAL_IN:
      return BTID.match(_DIAL_IN_PREFIX) ? BTID : `${_DIAL_IN_PREFIX}-${BTID}`
    case CONTROLLER:
      return `${_CONTROLLER_PREFIX}-${BTID}`
    default:
      return `${_READ_ONLY_PREFIX}-${BTID}`

  }

}

/**
* Returns the pure username from an observer username
* @param username The username to get the pure username from
* @returns The pure username
*/
export function getPureUsername (username: string): string {

  return username.replace(new RegExp(`${_WATCH_NAME_PREFIX}-|${_OBSERVER_PREFIX}-|${_READ_ONLY_PREFIX}-|${_DIAL_IN_PREFIX}-`, 'gi'), '')

}

/**
 * This method determines the remote user's role from their username
 * @param username The user's ID.
 * @returns A string constant representing the user's role.
 */
function getRoleFromUsername (username = ''): Role {

  const watchRegex = new RegExp(`^${_WATCH_NAME_PREFIX}`)
  if (username.match(watchRegex) !== null) return WATCH

  const observerRegex = new RegExp(`^${_OBSERVER_PREFIX}`)
  if (username.match(observerRegex) !== null) return OBSERVER

  const roRegex = new RegExp(`^${_READ_ONLY_PREFIX}`)
  if (username.match(roRegex) !== null) return READONLY

  const dialInRegex = new RegExp(`^${_DIAL_IN_PREFIX}`)
  if (username.match(dialInRegex) !== null) return DIAL_IN

  const controllerRegex = new RegExp(`^${_CONTROLLER_PREFIX}`)
  if (username.match(controllerRegex) !== null) return CONTROLLER

  return PRESENTER

}

/**
 * @param identity This method determines whether the user's role is PRESENTER
 */
export function isPresenter (identity = ''): boolean {

  if (identity === '') return false
  return getRoleFromUsername(identity) === PRESENTER

}

export function isDialIn (identity: string): boolean {

  if (identity === '') return false
  return getRoleFromUsername(identity) === DIAL_IN

}

export function isWatchScreen (identity = ''): boolean {

  if (identity === '') return false
  return getRoleFromUsername(identity) === WATCH

}

export function isObserver (identity = ''): boolean {

  if (identity === '') return false
  return getRoleFromUsername(identity) === OBSERVER

}

export function isController (identity = ''): boolean {

  if (identity === '') return false
  return getRoleFromUsername(identity) === CONTROLLER
}

export default {
  getUsername,
  getRoleFromUsername,
  getPureUsername,
  isPresenter,
  isDialIn,
  isObserver,
  isWatchScreen
}
